import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from "reactstrap";
import { Config } from '../../../Utils/Config';

const FreeAccountConfirmation = (props) => {
    return (
        <div className='thank-you-page'>
            <Container>
                <Row>
                    <Col className='text-center'>
                        <div className='thank-u-center'>
                            <h2>Thank You!</h2>
                            <p>Please check your email for further instructions on how to complete your accout setup.</p>
                            <hr />
                            <div className='support-msg'>
                                <p>Having trouble? <a href={Config.ContactUrl}>Contact us</a></p>
                                <Link to={'/'} className='market-btn'>Continue to Homepage</Link>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default FreeAccountConfirmation;